var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 44 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9345 1.06617V0H36.1005C34.6634 0 33.2728 0.556264 32.253 1.57608L28.2664 5.56263C26.2268 7.60227 25.2533 10.3836 25.2533 13.2576C25.2533 15.0191 23.8163 16.2243 22.1475 16.2243C20.5714 16.2243 19.3199 14.88 19.3199 13.1649C19.3199 10.3372 18.3 7.55591 16.3068 5.56263L12.3202 1.57608C11.3004 0.556264 9.95608 0 8.51907 0H0.638672V1.06617H2.72466C3.65177 1.06617 4.48616 1.43701 5.18149 2.13234L18.0683 15.0191L0.638672 32.4487H8.28729L18.5318 22.2042C19.0417 21.6943 19.3199 21.0453 19.3199 20.35C19.3199 18.5421 20.5714 17.3369 22.1475 17.3369C23.8163 17.3369 25.2533 18.403 25.2533 20.2573C25.2533 20.9989 25.5315 21.6943 26.0877 22.2505L36.2859 32.4487H43.9345L26.5049 15.0191L39.3917 2.13234C40.087 1.43701 40.9214 1.06617 41.8949 1.06617H43.9345Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9345 1.06617V0H36.1005C34.6634 0 33.2728 0.556264 32.253 1.57608L28.2664 5.56263C26.2268 7.60227 25.2533 10.3836 25.2533 13.2576C25.2533 15.0191 23.8163 16.2243 22.1475 16.2243C20.5714 16.2243 19.3199 14.88 19.3199 13.1649C19.3199 10.3372 18.3 7.55591 16.3068 5.56263L12.3202 1.57608C11.3004 0.556264 9.95608 0 8.51907 0H0.638672V1.06617H2.72466C3.65177 1.06617 4.48616 1.43701 5.18149 2.13234L18.0683 15.0191L0.638672 32.4487H8.28729L18.5318 22.2042C19.0417 21.6943 19.3199 21.0453 19.3199 20.35C19.3199 18.5421 20.5714 17.3369 22.1475 17.3369C23.8163 17.3369 25.2533 18.403 25.2533 20.2573C25.2533 20.9989 25.5315 21.6943 26.0877 22.2505L36.2859 32.4487H43.9345L26.5049 15.0191L39.3917 2.13234C40.087 1.43701 40.9214 1.06617 41.8949 1.06617H43.9345Z",
    fill: "url(#paint0_linear_2682_31209)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2682_31209",
    x1: 22.2914,
    y1: -13.9066,
    x2: 22.2914,
    y2: 41.4622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4350"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.f26da68760778e8188577f2370abfcb4.svg";
export { ForwardRef as ReactComponent };